import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { enterpriseApiClient } from '../../client';
import { IndyODataApi } from '../../openapi';
import type { WorkOrderViewModelODataResponseViewModel } from '../../openapi';
import { workOrderKeys } from '../constants';
import { CACHE_TIMINGS } from '@api/constants';

type ODataQueryParams = {
  $filter?: string;
  $select?: string;
  $orderby?: string;
  $top?: number;
  $skip?: number;
  $count?: boolean;
};

type UseWorkOrdersODataParams = {
  queryParams: ODataQueryParams;
  associatedEmployeeUserName?: string;
  associatedEmployeeCompanyName?: string;
  enabled?: boolean;
};

export const useWorkOrdersOData = ({
  queryParams,
  associatedEmployeeUserName,
  associatedEmployeeCompanyName,
  enabled = true
}: UseWorkOrdersODataParams) => {
  const indyODataApi = new IndyODataApi(
    undefined,
    undefined,
    enterpriseApiClient
  );

  const queryKey = useMemo(
    () =>
      workOrderKeys.odata({
        ...queryParams,
        associatedEmployeeUserName,
        associatedEmployeeCompanyName
      }),
    [
      JSON.stringify(queryParams),
      associatedEmployeeUserName,
      associatedEmployeeCompanyName
    ]
  );

  return useQuery<WorkOrderViewModelODataResponseViewModel, Error>({
    queryKey,
    queryFn: async () => {
      const response = await indyODataApi.apiOdataWorkOrdersGet({
        associatedEmployeeUserName,
        associatedEmployeeCompanyName,
        $filter: queryParams.$filter || undefined,
        $select: queryParams.$select || undefined,
        $orderby: queryParams.$orderby || undefined,
        $top: queryParams.$top,
        $skip: queryParams.$skip,
        $count: queryParams.$count
      });
      return response.data;
    },
    enabled,
    ...CACHE_TIMINGS.ODATA_SEARCH
  });
};
